import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { getAriaLabel } from 'shared/lib'
import { Typography } from 'shared/ui/Typography'
import { IconButton } from 'shared/ui/IconButton'
import modalFullScreenStore from './store/modalFullScreenStore'
import styles from './styles.module.scss'

export const ModalFullScreen = observer(() => {
  const { modals, closeModal, closeAllModals } = modalFullScreenStore
  const location = useLocation()

  useEffect(() => {
    closeAllModals()
  }, [location.pathname])

  const onClose = (id: string) => {
    closeModal(id)
  }

  return (
    <>
      {modals.map((modal) => {
        const { title, id, ModalContent, ModalContentProps } = modal
        const ariaLabelRoot = 'ModalFullScreen'

        return (
          <div
            key={modal.id}
            className={styles.wrap}
            aria-label={getAriaLabel(ariaLabelRoot, String(modal.title))}
          >
            <div className={styles.wrapContent}>
              <div className={styles.content}>
                <div className={styles.header} aria-label={getAriaLabel(ariaLabelRoot, 'header')}>
                  {title && (
                    <div
                      className={styles.title}
                      aria-label={getAriaLabel(ariaLabelRoot, 'header_title')}
                    >
                      <Typography variant={'body-xs-regular'} ariaLabel={'title'}>
                        {title}
                      </Typography>
                    </div>
                  )}
                </div>
                {ModalContent && <ModalContent {...ModalContentProps} />}
              </div>
              <div className={styles.closeButton}>
                <IconButton
                  icon={'close'}
                  size={'medium'}
                  color={'secondary'}
                  variant={'icon'}
                  onClick={() => onClose(id)}
                  ariaLabel={getAriaLabel(ariaLabelRoot, 'close')}
                />
              </div>
            </div>
          </div>
        )
      })}
    </>
  )
})
